<template>
    <el-dialog
        title="包含的分帐单"
        width="1100px"
        :visible="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'splitDetailDialog'"
        >
        <performance-table-box
            ref="transferDetailTable"
            :config="splitDetailConfig"
            :loading="loading"
            :tableData="totalData"
            :currentPage="searchParams.pageNo"
            :pageSize="searchParams.pageSize"
            :total="pageTotal"
            @size-change="sizeChange"
            @current-change="pageChange"
        ></performance-table-box>
    </el-dialog>
</template>
<script>
import PerformanceTableBox from '../../../../components/PerformanceTableBox';
import { splitDetailConfig } from './config.js';
import * as api from '@/modules/transport/otp/api/paymentRecord.js';
export default {
    name: 'SplitDetailDialog',
    components: {
        PerformanceTableBox
    },
    props: {
        componentData: {
            type: Object,
            default: () => {}
        }
    },
    data () {
        return {
            splitDetailConfig,
            loading: false,
            totalData: [],
            pageTotal: 0,
            searchParams: {
                pageSize: 10,
                pageNo: 1,
                param: {}
            },
            rowData: {},
            selected: []
        };
    },
    mounted () {
        this.getList();
    },
    methods: {
        getList () {
            this.loading = true;
            this.searchParams = this.getSearchData();
            api.queryDivideDtoByPage(this.searchParams)
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.totalData = res.data.list || [];
                        this.pageTotal = res.data.totalCount  || 0;
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        getSearchData () {
            const _searchData = {
                ...this.searchParams,
                param: {
                    tradeNoList: [this.componentData.tradeNo]
                }
            };
            return _searchData;
        },
        beforeClose () {
            this.$emit('update:splitDetailDialogShow', false);
        },
        // 切换当前页数
        pageChange (pageNo) {
            this.searchParams.pageNo = pageNo;
            this.getList();
        },
        // 切换分页显示条数
        sizeChange (pageSize) {
            this.searchParams.pageNo = 1;
            this.searchParams.pageSize = pageSize;
            this.getList();
        }
    }
};
</script>

<style lang="less">
.splitDetailDialog {
    height: 600px;
    overflow: auto;

    .el-dialog__body{
        padding: 0;
    }
}
</style>
